import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Button, Modal, Form } from "react-bootstrap";
import useApp from "../../hooks/useApp";
import useApi from "../../hooks/useApi";
import useReload from "../../hooks/useReload";

const ClientPolicyProcessing = (props) => {
  const { showAlert } = useApp();
  const { api } = useApi();
  const { policy = {} } = props;

  const { toggleReload } = useReload();

  const [showProcessForm, setShowProcessForm] = useState(false);
  const handleCloseProcessForm = () => setShowProcessForm(false);
  const handleShowProcessForm = () => setShowProcessForm(true);

  const [policyProcess, setPolicyProcess] = useState({
    PolicyItemId: policy.id,
    processed: "",
    processedRemark: "",
  });

  const saveProcess = async (e) => {
    e.preventDefault();

    if (!policyProcess?.processed) {
      showAlert("Please select a processing action", "error");
    } else {
      try {
        const data = {
          ...policyProcess,
          processed: policyProcess?.processed?.value || "",
        };
        const response = await api.add(`/policy-items/process`, data);
        if (response.ok) {
          setPolicyProcess({
            PolicyItemId: policy.id,
            processed: "",
            processedRemark: "",
          });
          showAlert("Policy processed", "success");
          handleCloseProcessForm();
          toggleReload();
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      <Button
        variant="outline-secondary me-2"
        size="xs"
        type="button"
        title="Add Process"
        onClick={() => handleShowProcessForm()}
      >
        <i className="bi bi-stoplights fs-5 me-2" />
        Process
      </Button>
      <Modal
        show={showProcessForm}
        onHide={handleCloseProcessForm}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Process Policy</Modal.Title>
        </Modal.Header>
        <Form autoComplete="off" onSubmit={saveProcess}>
          <Modal.Body>
            <Form.Group controlId="formAction">
              <Form.Label className="text-primary">
                Processing Action
              </Form.Label>
              <Select
                id="processing_action"
                options={[
                  {
                    value: "update",
                    label: "Log update",
                  },
                  {
                    value: "awaiting",
                    label: "Awaiting Renewal",
                  },
                  {
                    value: "terminated",
                    label: "Terminate",
                  },
                ]}
                onChange={(selectedOption) =>
                  setPolicyProcess({
                    ...policyProcess,
                    processed: selectedOption,
                  })
                }
                value={policyProcess?.processed || ""}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formRemark">
              <Form.Label className="text-primary">Remarks</Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Leave a comment here"
                rows={10}
                required
                value={policyProcess?.processedRemark}
                onChange={(e) =>
                  setPolicyProcess({
                    ...policyProcess,
                    processedRemark: e.target.value,
                  })
                }
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => handleCloseProcessForm()}
            >
              Close
            </Button>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default ClientPolicyProcessing;
